/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefProjectData } from '../../models/api-def-project-data';

export interface OrganizationsGetProjectById$Params {

/**
 * The ID of the organization to retrieve the project from
 */
  organizationId: string;

/**
 * The ID of the project to retrieve
 */
  projectId: string;
}

export function organizationsGetProjectById(http: HttpClient, rootUrl: string, params: OrganizationsGetProjectById$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefProjectData>> {
  const rb = new RequestBuilder(rootUrl, organizationsGetProjectById.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('projectId', params.projectId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiDefProjectData>;
    })
  );
}

organizationsGetProjectById.PATH = '/organizations/{organizationId}/projects/{projectId}';
